import * as React from 'react'
import { StringId } from '../localizer/stringId'
import { TextLocalizer } from '../localizer/localizer'
import * as st from './pageUnavailable.module.scss'
import * as utilityClasses from '../utilityClasses.module.scss'
import { AtfTreatmentProps } from '../../reducers/features'
import * as cn from 'classnames'
import { isTreatment } from '../../utils/utils'

export const PageUnavailable = () => (
  <MessageWrapper stringID={StringId.DV_DP_unavailable_page_message} />
)

export const OnlyPlaybackAvailableInGen4Message = ({ atfTreatment}: AtfTreatmentProps) => (
  <MessageWrapper stringID={StringId.DV_DP_only_playback_available_in_gen4_message} atfTreatment={atfTreatment}/>
)

interface IMessageWrapperProps extends AtfTreatmentProps{
  stringID: StringId
}

export const MessageWrapper = ({ stringID, atfTreatment }: IMessageWrapperProps) => (
  <div className={st.atfUnavailableBox}>
    <p className={cn(st.message, utilityClasses.fullWidth, {[st.messageRedesign]: isTreatment(atfTreatment, 'T1', 'T2', 'T3')})}><TextLocalizer stringID={stringID} /></p>
  </div>
)